module.exports = __webpack_public_path__ + "static/media/dollar.da4e14b5.svg";